import React, { Component } from "react";
import { compose } from "react-apollo";
import Table from "components/Table/Table";
import { withQuery } from "containers/withQuery";
import PencilButton from "components/ActionButtons/PencilButton";
import { LOCATIONS_QUERY } from "../generalRegisterQueries";
import LocationEdit from "./LocationEdit";

const headers = [
  {
    label: "Id", key: "id",
  },
  {
    label: "Local", key: "name",
  },
  {
    label: "Código", key: "code",
  },
  {
    label: "Sensor", key: "sensor",
  },
  {
    label: "", key: "action",
  },
];

class LocationsTable extends Component {
  state = {
    currentEditId: null,
  }

  onFinishEdit = () => this.setState({ currentEditId: null });

  render() {
    const { currentEditId } = this.state;
    return (
      <React.Fragment>
        <Table
          headers={headers}
          matchHeaders
          items={[...this.props.inventoryLocations]
            .sort((a, b) => a.id - b.id)
            .map(location => ({
              ...location,
              sensor: location.sensor ? location.sensor.name : "-",
              action: (
                <PencilButton
                  onPencilEditClick={() => this.setState({
                    currentEditId: location.id
                  })}
                />
              )
            }))
          }
        />
        {currentEditId !== null && (
          <LocationEdit id={currentEditId} onFinishEdit={this.onFinishEdit} />
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withQuery({ query: LOCATIONS_QUERY }),
)(LocationsTable);
